import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImageLightboxState } from '@core/models';

const SWIPE_THRESHOLD_PX = 48;

@Component({
  selector: 'app-image-lightbox',
  imports: [CommonModule],
  templateUrl: './image-lightbox.component.html',
  styleUrl: './image-lightbox.component.scss',
})
export class ImageLightboxComponent {
  @Input({ required: true }) state!: ImageLightboxState;

  @Output() close = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();
  @Output() select = new EventEmitter<number>();

  private touchStartX = 0;

  get currentPhoto() {
    return this.state.photos[this.state.currentIndex];
  }

  get counter(): string {
    const current = String(this.state.currentIndex + 1).padStart(2, '0');
    const total = String(this.state.photos.length).padStart(2, '0');
    return `${current} · ${total}`;
  }

  onTouchStart(event: TouchEvent): void {
    this.touchStartX = event.changedTouches[0].clientX;
  }

  onTouchEnd(event: TouchEvent): void {
    const deltaX = event.changedTouches[0].clientX - this.touchStartX;
    if (Math.abs(deltaX) < SWIPE_THRESHOLD_PX) return;

    if (deltaX < 0) {
      this.next.emit();
    } else {
      this.previous.emit();
    }
  }
}
